import React, { useEffect, useState } from 'react';
import { Button, MenuItem, TextField, Typography } from '@material-ui/core';
import apiURL from '../../apiURL';

export const ContestWinner = ({ contestId, eventId, onSuccess }: {
    contestId: string;
    eventId: string;
    onSuccess: () => void;
}) => {
    const [number, setNumber] = useState('');
    const [prizeId, setPrizeId] = useState('');
    const [prizes, setPrizes] = useState<any[]>([]);
    const [busy, setBusy] = useState(false);
    const [message, setMessage] = useState('');

    useEffect(() => {
        if (!contestId) return;
        const token = localStorage.getItem('auth') || '';
        fetch(`${apiURL}/contest-admin/${contestId}`, {
            headers: { Authorization: `Bearer ${token}` }
        })
            .then(r => {
                if (!r.ok) throw new Error();
                return r.json();
            })
            .then(data => setPrizes(
                (data.prizes || []).filter((p: any) =>
                    p.enabled && p.quantity > 0
                )
            ))
            .catch(() => setMessage('Cadeaux indisponibles.'));
    }, [contestId]);

    const assign = async () => {
        const ticket = Number(number);
        if (!eventId || !Number.isSafeInteger(ticket) || ticket < 1 || !prizeId || busy) return;
        const prize = prizes.find(p => p.id === prizeId);
        if (!prize) return;

        if (!window.confirm(
            `Confirmer le ticket n° ${ticket} comme gagnant de « ${prize.name} » ? Aucun SMS ne sera envoyé.`
        )) return;

        setBusy(true);
        setMessage('');
        try {
            const token = localStorage.getItem('auth') || '';
            const response = await fetch(
                `${apiURL}/contest-admin/${contestId}/winner`,
                {
                    method: 'POST',
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        event_id: eventId,
                        number: ticket,
                        prize_id: prizeId
                    })
                }
            );
            if (!response.ok) {
                const error = await response.json().catch(() => ({}));
                throw new Error(error.message || 'Attribution impossible');
            }
            setMessage(`Ticket n° ${ticket} désigné gagnant.`);
            setNumber('');
            setPrizeId('');
            onSuccess();
        } catch (e: any) {
            setMessage(e.message || 'Attribution impossible.');
        } finally {
            setBusy(false);
        }
    };

    return (
        <div style={{ marginTop: 28, padding: 20, border: '1px solid #ddd', borderRadius: 8 }}>
            <Typography variant="h6">Désigner un gagnant</Typography>
            <Typography paragraph>
                Attribution manuelle uniquement. Aucun SMS automatique.
            </Typography>
            <TextField
                label="Numéro du ticket gagnant"
                type="number"
                fullWidth
                margin="normal"
                value={number}
                inputProps={{ min: 1, step: 1 }}
                onChange={e => {
                    const value = e.target.value;
                    if (value === '' || /^[1-9][0-9]*$/.test(value)) {
                        setNumber(value);
                    }
                }}
            />
            <TextField
                select
                label="Cadeau à attribuer"
                fullWidth
                margin="normal"
                value={prizeId}
                onChange={e => setPrizeId(e.target.value)}
            >
                {prizes.map(p => (
                    <MenuItem key={p.id} value={p.id}>
                        {p.name} — {p.quantity} exemplaire(s)
                    </MenuItem>
                ))}
            </TextField>
            <Button
                variant="contained"
                color="primary"
                disabled={!eventId || !prizeId || !Number.isSafeInteger(Number(number)) || Number(number) < 1 || busy}
                onClick={assign}
            >
                {busy ? 'Attribution en cours…' : 'Désigner gagnant'}
            </Button>
            {message && <Typography style={{ marginTop: 12 }}>{message}</Typography>}
        </div>
    );
};
